import { computed, ref } from 'vue';

export const isPageLoading = ref(false);
export const isNavigationLoading = ref(false);

export const isLoading = computed(
    () => isPageLoading.value || isNavigationLoading.value
);

export function setLoading(value) {
    isPageLoading.value = Boolean(value);
}

export function setNavigationLoading(value) {
    isNavigationLoading.value = Boolean(value);
}
